
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tac",
      function () {
        return require("private-next-pages/tac.tsx");
      }
    ]);
  